export enum HttpCodes {
  SUCCESS_200 = 200,
  BAD_REQUEST_400 = 400,
  UNAUTHORIZED_401 = 401,
  NOT_FOUND_404 = 404,
  SERVICE_UNAVAILABLE_503 = 503,
  VERSION_NOT_SUPPORTED_505 = 505,
  NOTVALID_403 = 403,
}
